import type { TranslatableTarget } from './compositionTypes';

/**
 * PLAT-10112 — the quick-edit popover / canvas dispatches the open element's id
 * back as `compositionElementId`. When that id actually belongs to a standalone
 * text overlay (the extractor emitted a `kind: 'text'` target for it), it must
 * be routed as `textElementId` so the backend keys the Variant-D reference;
 * otherwise it stays a `compositionElementId`.
 *
 * Returns the field fragment to spread into the
 * `retranslateCompositionPhrases` args — empty when there is no id. Centralizes
 * the routing so the three dispatch surfaces (Content Studio clip preview,
 * Creator Studio canvas, Creator Studio left panel) can't drift.
 */
export function routeRetranslateTargetId(
  compositionElementId: string | undefined,
  targets: TranslatableTarget[],
):
  | { textElementId: string }
  | { compositionElementId: string }
  | Record<string, never> {
  if (!compositionElementId) return {};
  const isTextTarget = targets.some(
    t => t.kind === 'text' && t.textElementId === compositionElementId,
  );
  return isTextTarget
    ? { textElementId: compositionElementId }
    : { compositionElementId };
}
